import Swiper from "swiper";
import {Navigation} from "swiper/modules";

document.addEventListener('DOMContentLoaded', function (dom) {
    const servicesBlock = dom.target.querySelector('.services__block')

    if (servicesBlock) {
        const swiper = new Swiper('.swiper', {
            modules: [Navigation],
            slidesPerView: 1.1,
            grid: {
                rows: 1,
            },
            spaceBetween: 15,
            navigation: {
                nextEl: '.arrows__swiper-next',
                prevEl: '.arrows__swiper-prev',
            },
            breakpoints: {
                '768': {
                    slidesPerView: 2.1,
                }
            }
        });
    }
});